import {Button, Icon} from '@gravity-ui/uikit';
import {OctagonXmark, PaperPlane} from '@gravity-ui/icons';
import {FundraiserStoryDetailedModel, ProjectStoryDetailedModel, StoryDetailedModel} from '../../../../entities';
import {useState} from 'react';
import {PublishStoryModal, UnpublishStoryModal} from '../';

interface PublishStoryButtonProps {
  story: StoryDetailedModel | FundraiserStoryDetailedModel | ProjectStoryDetailedModel;
  refetchStory: () => void;
}

export const PublishStoryButton = ({story, refetchStory}: PublishStoryButtonProps) => {
  const isPublished = story?.publishedAt;
  const [isUnpublishModalOpen, setIsUnpublishModalOpen] = useState(false);
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);

  const handlePublishToggle = () => {
    if (story?.publishedAt) {
      setIsUnpublishModalOpen(true);
    } else {
      setIsPublishModalOpen(true);
    }
  };

  return (
    <>
      <Button view="normal" size={'m'} onClick={handlePublishToggle}>
        <Icon data={isPublished ? OctagonXmark : PaperPlane} />
        {isPublished ? 'Снять с публикации' : 'Опубликовать'}
      </Button>
      <PublishStoryModal
        open={isPublishModalOpen}
        setOpen={setIsPublishModalOpen}
        storyId={story.id}
        refetchStory={refetchStory}
      />

      <UnpublishStoryModal
        open={isUnpublishModalOpen}
        setOpen={setIsUnpublishModalOpen}
        storyId={story.id}
        refetchStory={refetchStory}
      />
    </>
  );
};
